import { FC } from 'react';

import Table from 'modules/_shared/Table';

import EncumbrancesTableHeader from './components/EncumbrancesTableHeader';
import EncumbrancesTableBody from './components/EncumbrancesTableBody';

type EncumbrancesTableProps = {
  compact?: boolean;
};

const EncumbrancesTable: FC<EncumbrancesTableProps> = ({ compact = false }) => {
  const tableContent = (
    <>
      <EncumbrancesTableHeader />
      <EncumbrancesTableBody />
    </>
  );

  return <Table content={tableContent} scrollHorizontal compact={compact} />;
};

export default EncumbrancesTable;
